module.exports = __webpack_public_path__ + "img/DJI_0017.098e7d0d.jpg";